import { render, staticRenderFns } from "./Tatami.vue?vue&type=template&id=b00a6a96&scoped=true&"
import script from "./Tatami.vue?vue&type=script&lang=js&"
export * from "./Tatami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00a6a96",
  null
  
)

export default component.exports